import React from "react";
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { Typography, FormGroup, InputBase, Button, Link } from "@material-ui/core";

const FrameBlockResult = ({ link, apmType, icon, hideFrame }) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const onCopy = async () => {
        await navigator.clipboard.writeText(link);
    }

    return (
        <div className={classes.paymentModalInner}>
            <div>
                <img src={icon} alt={`${apmType}-logo`} className={classes.paymentModalBrandImg} />
            </div>
            <Typography align="center" className={classes.error} gutterBottom>
                {t('APM_complete_payment_label_1')}
            </Typography>
            <div className={classes.wrapper}>
                <FormGroup className={classes.cardForm}>
                  <InputBase
                    className={classes.cardInput}
                    name="cardName"
                    value={link}
                    variant="outlined"
                    fullWidth
                  />
                </FormGroup>
                <Button
                    className={classes.submitButton}
                    variant="contained"
                    color="secondary"
                    type="button">
                        <Link 
                            href={link}
                            underline="none"
                            rel="noreferrer noopener"
                            target="_blank"
                            className={classes.link}>
                            {'Open'}
                        </Link>
                </Button>
                <Button
                    className={classes.submitButton}
                    variant="contained"
                    color="secondary"
                    type="button"
                    onClick={onCopy}>
                    {'Copy'}
                </Button>
            </div>
            {
                !hideFrame && (
                    <iframe
                        id={`${apmType}-frame`}
                        className={classes.frameBlock}
                        src={link}
                        title={`${apmType}-link`}
                        frameBorder="0"
                        aria-hidden="true"
                    ></iframe>
                )
            }
        </div>
    )
}

export default FrameBlockResult;